"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORIES_TO_CONFIGS = exports.CustomizableConfigurationCategories = void 0;
const configuration_1 = require("./configuration");
var CustomizableConfigurationCategories;
(function (CustomizableConfigurationCategories) {
    CustomizableConfigurationCategories["Global"] = "Global";
    CustomizableConfigurationCategories["Team"] = "Team";
    CustomizableConfigurationCategories["IterationReview"] = "IterationReview";
    CustomizableConfigurationCategories["TeamAnalyticsCharts"] = "TeamAnalyticsCharts";
    CustomizableConfigurationCategories["PRSizeToMergeTimeChart"] = "PRSizeToMergeTimeChart";
    CustomizableConfigurationCategories["GoRetro"] = "GoRetro";
    CustomizableConfigurationCategories["DailyDevStats"] = "DailyDevStats";
    CustomizableConfigurationCategories["TeamComparison"] = "TeamComparison";
    CustomizableConfigurationCategories["DailyDevStatsBadgeGeneral"] = "DailyDevStatsBadgeGeneral";
    CustomizableConfigurationCategories["DailyDevStatsBadgeVelocity"] = "DailyDevStatsBadgeVelocity";
    CustomizableConfigurationCategories["DailyDevStatsBadgeHighPriorityTasks"] = "DailyDevStatsBadgeHighPriorityTasks";
    CustomizableConfigurationCategories["DailyDevStatsBadgePRSize"] = "DailyDevStatsBadgePRSize";
    CustomizableConfigurationCategories["DailyDevStatsBadgePRCycleTime"] = "DailyDevStatsBadgePRCycleTime";
    CustomizableConfigurationCategories["DailyDevStatsBadgeReviewedPRs"] = "DailyDevStatsBadgeReviewedPRs";
    CustomizableConfigurationCategories["TeamBadgesGeneral"] = "TeamBadgesGeneral";
    CustomizableConfigurationCategories["TeamBadgesVelocity"] = "TeamBadgesVelocity";
    CustomizableConfigurationCategories["TeamBadgesAvgPRAwaitingReviewTime"] = "TeamBadgesAvgPRAwaitingReviewTime";
    CustomizableConfigurationCategories["TeamBadgesAvgPRSize"] = "TeamBadgesAvgPRSize";
    CustomizableConfigurationCategories["TeamBadgesAvgPRCycleTimeBadge"] = "TeamBadgesAvgPRCycleTimeBadge";
    CustomizableConfigurationCategories["TeamBadgesPRReviewersPercentBadge"] = "TeamBadgesPRReviewersPercentBadge";
    CustomizableConfigurationCategories["TeamBadgesWorkDistributionBugsPercentBadge"] = "TeamBadgesWorkDistributionBugsPercentBadge";
    CustomizableConfigurationCategories["TeamBadgesMTTRBadge"] = "TeamBadgesMTTRBadge";
})(CustomizableConfigurationCategories = exports.CustomizableConfigurationCategories || (exports.CustomizableConfigurationCategories = {}));
exports.CATEGORIES_TO_CONFIGS = {
    [CustomizableConfigurationCategories.Global]: [
        configuration_1.CustomizableConfiguration.CountryCode,
        configuration_1.CustomizableConfiguration.Locale,
        configuration_1.CustomizableConfiguration.TimeZone,
        configuration_1.CustomizableConfiguration.GitIgnoreFileList,
        configuration_1.CustomizableConfiguration.DeploymentDetection,
        configuration_1.CustomizableConfiguration.AcumenUiVersion
    ],
    [CustomizableConfigurationCategories.Team]: [
        configuration_1.CustomizableConfiguration.EstimationMethod,
        configuration_1.CustomizableConfiguration.DevelopmentMethodology,
        configuration_1.CustomizableConfiguration.DevCycle,
        configuration_1.CustomizableConfiguration.TimeZone
    ],
    [CustomizableConfigurationCategories.IterationReview]: [
        configuration_1.CustomizableConfiguration.EstimationMethod,
        configuration_1.CustomizableConfiguration.DevelopmentMethodology,
        configuration_1.CustomizableConfiguration.DevCycle,
        configuration_1.CustomizableConfiguration.PlannedGracePeriod,
        configuration_1.CustomizableConfiguration.SubtaskSprintStrategy,
        configuration_1.CustomizableConfiguration.ExcludedObstacles,
    ],
    [CustomizableConfigurationCategories.TeamAnalyticsCharts]: [
        configuration_1.CustomizableConfiguration.AnalyticsChartList
    ],
    [CustomizableConfigurationCategories.PRSizeToMergeTimeChart]: [
        configuration_1.CustomizableConfiguration.PrSizeToMergeTimeFastThreshold,
        configuration_1.CustomizableConfiguration.PrSizeToMergeTimeSlowThreshold
    ],
    [CustomizableConfigurationCategories.GoRetro]: [
        configuration_1.CustomizableConfiguration.CountryCode,
        configuration_1.CustomizableConfiguration.Locale,
        configuration_1.CustomizableConfiguration.TimeZone,
        configuration_1.CustomizableConfiguration.SubtaskSprintStrategy,
        configuration_1.CustomizableConfiguration.GoretroEstimationMethod,
        configuration_1.CustomizableConfiguration.PlannedGracePeriod,
        configuration_1.CustomizableConfiguration.SprintIds,
        configuration_1.CustomizableConfiguration.BoardIds,
        configuration_1.CustomizableConfiguration.DoneStatuses,
        configuration_1.CustomizableConfiguration.ContributorFilters
    ],
    [CustomizableConfigurationCategories.DailyDevStats]: [
        configuration_1.CustomizableConfiguration.WorkforceHealthSelectedMetrics
    ],
    [CustomizableConfigurationCategories.TeamComparison]: [
        configuration_1.CustomizableConfiguration.TeamComparisonSelectedMetrics
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgeGeneral]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesLowActivityPercent,
        configuration_1.CustomizableConfiguration.DevStatsBadgesMinNumberOfMergedPrsForPositiveBadges,
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgeVelocity]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocitySuperStarPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocityNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocityNeedAttentionPrevPeriodDecreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocityOnTheRisePrevPeriodIncreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocityOnTheRiseMinPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesVelocityCalculationSource
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgeHighPriorityTasks]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPriorityDisable,
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPrioritySuperStarPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPriorityTeamPlayerPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPriorityOnTheRisePrevPeriodIncreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPriorityOnTheRiseMinPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesHighPriorityMinNumberOfCompletedTasks,
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgePRSize]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeSuperStarPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeSuperStarPrSizeThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionPrevPeriodPrSizeIncreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionMinPRSizeThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeOnTheRisePrSizeThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRSizeOnTheRisePrevPeriodPrSizeDecreasePercentageThreshold,
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgePRCycleTime]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeSuperStarPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionPrevPeriodIncreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionMinPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeOnTheRisePrevPeriodDecreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesPRCycleTimeOnTheRiseMaxPercentileThreshold,
    ],
    [CustomizableConfigurationCategories.DailyDevStatsBadgeReviewedPRs]: [
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsSuperStarPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsNeedAttentionOverTeamPercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsOnTheRisePrevPeriodIncreasePercentageThreshold,
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsTeamPlayerRatioForMergedAndReviewedPrs,
        configuration_1.CustomizableConfiguration.DevStatsBadgesReviewedPRsTeamPlayerMinPercentileThreshold,
    ],
    [CustomizableConfigurationCategories.TeamBadgesGeneral]: [
        configuration_1.CustomizableConfiguration.TeamBadgesNumberOfPeriodsForTrendCalculation
    ],
    [CustomizableConfigurationCategories.TeamBadgesVelocity]: [
        configuration_1.CustomizableConfiguration.TeamBadgesVelocityTopPerformerPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesVelocityOnTheRisePercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesVelocityNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesVelocityDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesAvgPRAwaitingReviewTime]: [
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewTopPerformerAwaitingReviewHours,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewNeedAttentionAwaitingReviewHours,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesAvgPRSize]: [
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPrSizeThresholdForTopPercentile,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPrSizeThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeOnTheRisePercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeNeedAttentionPrSizeThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeNeedAttentionNegativeTrendPrSizeThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRSizeDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesAvgPRCycleTimeBadge]: [
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHoursForTopPercentile,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeUseTopPerformerThresholdForTopPercentile,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeOnTheRisePercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPrCycleTimeThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionNegativeTrendPrCycleTimeThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesPRReviewersPercentBadge]: [
        configuration_1.CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeTopPerformerPercentageOfReviewers,
        configuration_1.CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeNeedAttentionPercentageOfReviewers,
        configuration_1.CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesWorkDistributionBugsPercentBadge]: [
        configuration_1.CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeTopPerformerBugsPercentThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeOnTheRiseBugsPercentThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeNeedAttentionBugsPercentThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeDisable
    ],
    [CustomizableConfigurationCategories.TeamBadgesMTTRBadge]: [
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerPercentileThreshold,
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerMttrThresholdHoursForTopPercentile,
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerMttrThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeNeedAttentionMttrThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeNeedAttentionNegativeTrendMttrThresholdHours,
        configuration_1.CustomizableConfiguration.TeamBadgesMTTRBadgeDisable
    ],
};
//# sourceMappingURL=categories.js.map